export function transformPayment(payment) {
  return {
    id: payment.id,
    name: payment.name,
    paymentDate: payment.paymentDate,
    amount: payment.amount,
    description: payment.description,
    fileAttachments: payment.fileAttachments,
    createdBy: payment.createdById,
    canDelete: payment.deleteableOob,
    canEdit: payment.updatebleOob,
  }
}

export function transformPaymentForServer(payment) {
  return {
    name: payment.name,
    paymentDate: payment.paymentDate,
    amount: payment.amount,
    description: payment.description,
    fileAttachments: payment.fileAttachments,
  }
}
